import { createStyles, Theme } from '@material-ui/core/styles';
import { accentRegular } from '#web-components/styles';

const styles = ({
  spacing, breakpoints, colors, flags,
}: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: spacing(2),
    borderRadius: colors.navigation.navLink.corner,
    boxSizing: 'border-box',
    position: 'relative',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  name: {
    [breakpoints.up('lg')]: {
      ...accentRegular,
    },
  },
  icon: {
    marginRight: spacing(2),
    height: 24,
    width: 24,
    display: flags.showIcons ? 'default' : 'none',
    '& path': {
      fill: colors.navigation.navLink.enabled.icon,
    },
  },
  enabled: {
    color: colors.navigation.navLink.enabled.name,
    '&:hover': {
      background: colors.navigation.navLink.hovered.fill,
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        height: '100%',
        borderLeft: `2px solid ${colors.navigation.navLink.hovered.stroke}`,
      },
    },
  },
  selected: {
    background: colors.navigation.navLink.selected.fill,
    color: colors.navigation.navLink.selected.name,
    '& path': {
      fill: colors.navigation.navLink.selected.icon,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      height: '100%',
      borderLeft: `2px solid ${colors.navigation.navLink.selected.stroke}`,
    },
  },
  disabled: {
    background: colors.navigation.navLink.disabled.fill,
    color: colors.navigation.navLink.disabled.name,
    cursor: 'default',
    '& path': {
      fill: colors.navigation.navLink.disabled.icon,
    },
  },
});

export default styles;
